import React, { useState } from "react";
import "./displayYoutubeVideos.css";
import YouTube from "react-youtube";

function DisplayYoutubeVideos() {
	const [selectedUrl, setSelectedUrl] = useState("_gU4dGlrGis");
	const youtubeDummyVideos = ["_gU4dGlrGis", "VxOXhkLEcyQ"];
	const opts = {
		height: "450",
		// width: '640',
		playerVars: {
			autoplay: 1,
			controls: 1,
			showinfo: 0,
			rel: 0,
			fs: 1,
		},
	};
	return (
		<div className="container-fluid bg-dark" style={{ height: "fit-content" }}>
			<div className="row py-4 ">
				<div
					className="col-lg-12 d-flex align-items-center"
					style={{ padding: "0 10rem" }}
				>
					{/* <div className="d-flex justify-content-center container"> */}
					<YouTube
						videoId={selectedUrl}
						iframeClassName="video-width w-100 rounded-4"
						className="videoWidth col-12 "
						opts={opts}
					/>
					{/* </div> */}
				</div>
				<div className="col-lg-12 d-flex gap-4 justify-content-center mt-3">
					{youtubeDummyVideos.map((item, index) => {
						return (
							<img
								key={index}
								onClick={() => setSelectedUrl(item)}
								src={`http://img.youtube.com/vi/${item}/0.jpg`}
								alt="thumbnail"
								className="d-flex justify-content-center mb-3 video-thumbnail rounded-4 col-3"
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
}

export default DisplayYoutubeVideos;
